
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { ServerModel } from 'models/generated/Distribution.Api.Models.Server';


const _distribution_ServerControllerHelper = new Map<string, Object>();
_distribution_ServerControllerHelper.set('GetServers', ServerModel);


export const distribution_ServerControllerHelper = _distribution_ServerControllerHelper;

